const levelType = {
  subMenu: 1,
  menuGroup: 2,
  menuItem: 3,
};
const sidebar = false;
export default { levelType, sidebar };
